import { Injectable } from '@angular/core';
import * as firebase from 'firebase';

//search en select
class Afe {
  public id: number;
  public name: string;
  public codigo: string;
  public proyecto: string;
  public area:string
  public codigoCompania:string
  public afeNIT:string
}
class Cuenta {
  public id: number;
  public name: string;
}
class Proyecto {
  public id: number;
  public name: string;
}
class Vehiculo {
  public id: number;
  public name: string;
}

class Regional {
  public id: number;
  public name: string;
}

class Unidad {
  public id: number;
  public name: string;
}



@Injectable({
  providedIn: 'root'
})
export class ServiGetPostsService {

    idDeProveedorseleccionado

    //search select AFE
    listadeafes: Afe[];
    objetodeafe: Afe;
  
    //search select Cuenta
    listadecuentas: Cuenta[];
    objetodecuentas: Cuenta;
  
    //search select Proyecto
    listadeproyectos: Proyecto[];
    objetodeproyectos: Proyecto;

    //search select Regional
    listaderegionales: Regional[];
    objetoderegionales: Regional;
  
     //search select Vehiculo
     listadevehiculos: Vehiculo[];
     objetodevehiculos: Vehiculo;

      //search select UNidad
      listadeunidades: Unidad[];
      objetodeunidades: Unidad;
 
     


     //contenidos de seleccion multiple
  arraydeafes = [];
  cursordeafes;
  arraydecuentas = [];
  cursordecuentas;
  arraydeproyectos = [];
  cursordeproyectos;
  arrayderegionales = [];
  cursorderegionales;
  arraydevehiculos = [];
  cursordevehiculos;
  arraydetarifas = [];
  cursordetarifas;
  arraydeproveedores = [];
  cursordeproveedores;
  arraydeunidades = [];
  cursordeunidades;



  constructor() {
        //search select
        this.listadeafes = [];
        this.listadecuentas = [];
        this.listadeproyectos = [];
        this.listadevehiculos = [];
        this.listaderegionales = [];
        this.listadeunidades =[]

   }

   cargaitemsdeseleccion(parametroacargar,callback) {

    if(parametroacargar == 'afe'){
      this.arraydeafes = [];
      this.cursordeafes = 0;
      this.listadeafes = [];
      //QUERY DE AFES
        let querydeafes = firebase.firestore().collection("afes").where("activo","==",true);
        querydeafes.get().then((docs) => {
          docs.forEach((doc) => {
            this.arraydeafes.push(doc);
            
            this.listadeafes.push( { id:this.arraydeafes.length-1 , name: doc.data().codigoafe+" - "+doc.data().proyecto, codigo: doc.data().codigoafe, proyecto:doc.data().proyecto, area:doc.data().area, codigoCompania:doc.data().codigoCompania, afeNIT:doc.data().afeNIT   } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto
          });
          this.cursordeafes = this.arraydeafes[this.arraydeafes.length - 1];
          console.log(this.arraydeafes);
          // callback()
        }).catch((err) => {
          console.log(err);
        });
    }else

    if(parametroacargar == "cuentas"){
      this.arraydecuentas = [];
      this.cursordecuentas = 0;
      this.listadecuentas = [];
        //Query de CUENTAS
        let querydecuentas = firebase.firestore().collection("cuentas");
        querydecuentas.get().then((docs) => {
          docs.forEach((doc) => {
            this.arraydecuentas.push(doc);
            console.log("arraydecuentas: " + this.arraydecuentas);

            this.listadecuentas.push( { id:this.arraydecuentas.length-1 , name: doc.data().cuenta } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto

          });
          this.cursordecuentas = this.arraydecuentas[this.arraydecuentas.length - 1];
          console.log(this.arraydecuentas);
        }).catch((err) => {
          console.log(err);
        });
    }else

    if(parametroacargar=="regionales"){
      this.arrayderegionales = [];
      this.cursorderegionales = 0;
      this.listaderegionales = [];
      //Query de Regionales
      let queryderegionales = firebase.firestore().collection("regionales");
      queryderegionales.get().then((docs) => {
        docs.forEach((doc) => {
          this.arrayderegionales.push(doc);
          this.listaderegionales.push( { id:this.arrayderegionales.length-1 , name: doc.data().regional } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto

        });
        this.cursorderegionales = this.arrayderegionales[this.arrayderegionales.length - 1];

      }).catch((err) => {
        console.log(err);
      });
    }else

    if(parametroacargar=="equiposHomologados"){
      this.arraydevehiculos = [];
      this.cursordevehiculos = 0;
      this.listadevehiculos = [];
        //Query de VEHICULOS
        let querydevehiculos = firebase.firestore().collection("equiposHomologados");
        querydevehiculos.get().then((docs) => {
          docs.forEach((doc) => {
            this.arraydevehiculos.push(doc);

            this.listadevehiculos.push( { id:this.arraydevehiculos.length-1 , name: doc.data().tipo } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto

          });
          this.cursordevehiculos = this.arraydevehiculos[this.arraydevehiculos.length - 1];
      
        }).catch((err) => {
          console.log(err);
        });
    }else

    if(parametroacargar=="vehiculos"){
      this.arraydevehiculos = [];
      this.cursordevehiculos = 0;
      this.listadevehiculos = [];
        //Query de VEHICULOS
        let querydevehiculos = firebase.firestore().collection("vehiculos");
        querydevehiculos.get().then((docs) => {
          docs.forEach((doc) => {
            this.arraydevehiculos.push(doc);
            console.log(doc.data().tipo )
            this.listadevehiculos.push( { id:this.arraydevehiculos.length-1 , name: doc.data().tipo } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto

          });
          this.cursordevehiculos = this.arraydevehiculos[this.arraydevehiculos.length - 1];
      
        }).catch((err) => {
          console.log(err);
        });
    }


    if(parametroacargar=="unidades"){
      this.arraydeunidades = [];
      this.cursordeunidades = 0;
      this.listadeunidades = [];
        //Query de UNIDADES
        let querydeUnidades = firebase.firestore().collection("unidades");
        querydeUnidades.get().then((docs) => {
          docs.forEach((doc) => {
            this.arraydeunidades.push(doc);

            this.listadeunidades.push( { id:this.arraydeunidades.length-1 , name: doc.data().name } );//como para que funcione el search select se necesita que sea un objeto, empujamos en el array de lista de afes un objeto

          });
          this.cursordeunidades = this.arraydeunidades[this.arraydeunidades.length - 1];
      
        }).catch((err) => {
          console.log(err);
        });
    }

    


    

    

  



    

   
    
    
    

  



    

  

     

  

    callback()

  }///fin de cargaitemsdeseleccion


  





}//fin de clase


